import { NavLink } from "react-router-dom";
import "@/community.css";

const LINKS = [
  { to: "/experience", label: "The Experience", id: "experience" },
  { to: "/bulletin", label: "Weekly Bulletin", id: "bulletin" },
  { to: "/events", label: "Experiences", id: "events" },
  { to: "/community-wall", label: "Community Wall", id: "wall" },
  { to: "/prive", label: "Privé Club", id: "prive" },
  { to: "/become-a-jenova-girl", label: "Become a Jenova Girl", id: "join" },
  { to: "/my-jenova", label: "My Jenova", id: "my" },
];

export function CommunityNav() {
  return (
    <div className="sticky top-16 md:top-20 z-40 bg-[#FBF8F3]/90 backdrop-blur-xl border-b border-[#E8DCCB]/70">
      <nav
        data-testid="community-subnav"
        className="jc-scroll-x max-w-[1600px] mx-auto px-6 md:px-12 lg:px-16 flex items-center gap-7 md:gap-10 overflow-x-auto h-12"
      >
        {LINKS.map((l) => (
          <NavLink
            key={l.to}
            to={l.to}
            data-testid={`community-nav-${l.id}`}
            className={({ isActive }) =>
              `shrink-0 text-[11px] uppercase tracking-[0.22em] font-sans transition-colors pb-0.5 border-b ${
                isActive ? "text-[#2B2522] border-[#C9A97A]" : "text-[#7A6A62] border-transparent hover:text-[#2B2522]"
              }`
            }
          >
            {l.label}
          </NavLink>
        ))}
      </nav>
    </div>
  );
}

export default function CommunityLayout({ children }) {
  return (
    <div className="jc-root pt-16 md:pt-20 min-h-screen">
      <CommunityNav />
      {children}
    </div>
  );
}
